// CLIENTS
export const MOCK_CLIENTS = [
  { id: 1, name: 'River Bank & Trust', domain: 'riverbankandtrust.com', brand_color: '#1A3A5C', logo_path: null, scan_freq: 'daily', active: 1, created_at: '2026-01-01T00:00:00Z' },
  { id: 2, name: 'Coastal Credit Union', domain: 'coastalcu.org', brand_color: '#0D4A3A', logo_path: null, scan_freq: 'weekly', active: 1, created_at: '2026-01-02T00:00:00Z' },
  { id: 3, name: 'First Metro Bank', domain: 'firstmetrobank.com', brand_color: '#2A1A5C', logo_path: null, scan_freq: 'weekly', active: 1, created_at: '2026-01-03T00:00:00Z' },
];

// KEYWORDS - Client 1: River Bank & Trust (Alabama)
const KW_DEFS_CLIENT1 = [
  { kw: 'Banks', locs: ['Huntsville AL', 'Birmingham AL', 'Montgomery AL'] },
  { kw: 'Checking account', locs: ['Huntsville AL', 'Birmingham AL', 'Montgomery AL'] },
  { kw: 'Mortgage loans', locs: ['Huntsville AL', 'Birmingham AL', 'Montgomery AL'] },
  { kw: 'Small business loans', locs: ['Huntsville AL', 'Birmingham AL', 'Montgomery AL'] },
];

// KEYWORDS - Client 2: Coastal Credit Union (Georgia)
const KW_DEFS_CLIENT2 = [
  { kw: 'Credit union', locs: ['Savannah GA', 'Atlanta GA', 'Augusta GA'] },
  { kw: 'Auto loans', locs: ['Savannah GA', 'Atlanta GA', 'Augusta GA'] },
  { kw: 'Savings account', locs: ['Savannah GA', 'Atlanta GA', 'Augusta GA'] },
  { kw: 'Personal loans', locs: ['Savannah GA', 'Atlanta GA', 'Augusta GA'] },
];

// KEYWORDS - Client 3: First Metro Bank (Florida)
const KW_DEFS_CLIENT3 = [
  { kw: 'Bank near me', locs: ['Miami FL', 'Orlando FL', 'Tampa FL'] },
  { kw: 'Business checking', locs: ['Miami FL', 'Orlando FL', 'Tampa FL'] },
  { kw: 'Home equity loan', locs: ['Miami FL', 'Orlando FL', 'Tampa FL'] },
  { kw: 'CD rates', locs: ['Miami FL', 'Orlando FL', 'Tampa FL'] },
];

let kwId = 1;
export const MOCK_KEYWORDS = [];

// Generate keywords for Client 1
for (const { kw, locs } of KW_DEFS_CLIENT1)
  for (const loc of locs)
    MOCK_KEYWORDS.push({ id: kwId++, client_id: 1, keyword: kw, location: loc, is_target: 1, created_at: '2026-01-01T00:00:00Z' });

// Generate keywords for Client 2
for (const { kw, locs } of KW_DEFS_CLIENT2)
  for (const loc of locs)
    MOCK_KEYWORDS.push({ id: kwId++, client_id: 2, keyword: kw, location: loc, is_target: 1, created_at: '2026-01-02T00:00:00Z' });

// Generate keywords for Client 3
for (const { kw, locs } of KW_DEFS_CLIENT3)
  for (const loc of locs)
    MOCK_KEYWORDS.push({ id: kwId++, client_id: 3, keyword: kw, location: loc, is_target: 1, created_at: '2026-01-03T00:00:00Z' });

// RANKINGS - Client 1: River Bank & Trust
const RANK_DATA_CLIENT1 = {
  'Banks|Huntsville AL': { rank: 4, snippet: 'River Bank & Trust — community banking Huntsville', competitors: ['Redstone Federal Credit Union', 'Regions Bank', 'BancorpSouth'] },
  'Banks|Birmingham AL': { rank: 7, snippet: 'Local banking services Birmingham AL', competitors: ['Regions Bank', 'BBVA USA', 'Wells Fargo'] },
  'Banks|Montgomery AL': { rank: 3, snippet: 'River Bank & Trust serving Montgomery', competitors: ['BancorpSouth', 'Trustmark Bank', 'Farmers Merchants'] },
  'Checking account|Huntsville AL': { rank: 2, snippet: 'Free checking accounts Huntsville AL', competitors: ['Redstone FCU', 'Regions Bank', 'PNC Bank'] },
  'Checking account|Birmingham AL': { rank: 5, snippet: 'Personal checking accounts Birmingham', competitors: ['BBVA USA', 'Trustmark Bank', 'Regions'] },
  'Checking account|Montgomery AL': { rank: 8, snippet: 'Checking account options Montgomery AL', competitors: ['BancorpSouth', 'Regions Bank', 'Chase'] },
  'Mortgage loans|Huntsville AL': { rank: 6, snippet: 'Home mortgage loans Huntsville Alabama', competitors: ['Rocket Mortgage', 'Regions Bank', 'USAA'] },
  'Mortgage loans|Birmingham AL': { rank: 11, snippet: 'Mortgage lenders Birmingham AL', competitors: ['Quicken Loans', 'Regions Bank', 'Truist'] },
  'Mortgage loans|Montgomery AL': { rank: 4, snippet: 'Mortgage loans Montgomery Alabama', competitors: ['Farmers & Merchants', 'BancorpSouth', 'Truist'] },
  'Small business loans|Huntsville AL': { rank: 3, snippet: 'Small business financing Huntsville AL', competitors: ['SBA.gov', 'Regions Bank', 'Redstone FCU'] },
  'Small business loans|Birmingham AL': { rank: 9, snippet: 'Business loans Birmingham Alabama', competitors: ['Regions Bank', 'BBVA USA', 'Wells Fargo'] },
  'Small business loans|Montgomery AL': { rank: 14, snippet: 'Small business loans Montgomery AL', competitors: ['Wells Fargo', 'BancorpSouth', 'Trustmark'] },
};

// RANKINGS - Client 2: Coastal Credit Union
const RANK_DATA_CLIENT2 = {
  'Credit union|Savannah GA': { rank: 2, snippet: 'Coastal Credit Union — member-owned Savannah', competitors: ['Georgia Heritage FCU', 'Navy FCU', 'Peach State FCU'] },
  'Credit union|Atlanta GA': { rank: 5, snippet: 'Best credit unions in Atlanta GA', competitors: ['Delta Community CU', 'Georgia United CU', 'LGE Community CU'] },
  'Credit union|Augusta GA': { rank: 3, snippet: 'Coastal Credit Union Augusta branch', competitors: ['Security Federal CU', 'SRP FCU', 'Peach State FCU'] },
  'Auto loans|Savannah GA': { rank: 1, snippet: 'Low rate auto loans Savannah GA', competitors: ['Capital One Auto', 'Navy FCU', 'Bank of America'] },
  'Auto loans|Atlanta GA': { rank: 8, snippet: 'Car financing Atlanta Georgia', competitors: ['Delta Community CU', 'PenFed', 'Ally Auto'] },
  'Auto loans|Augusta GA': { rank: 4, snippet: 'Auto loans Augusta GA — great rates', competitors: ['SRP FCU', 'Wells Fargo', 'Capital One'] },
  'Savings account|Savannah GA': { rank: 6, snippet: 'High yield savings Savannah', competitors: ['Marcus by Goldman', 'Ally Bank', 'Navy FCU'] },
  'Savings account|Atlanta GA': { rank: 12, snippet: 'Savings accounts Atlanta area', competitors: ['Delta Community CU', 'SunTrust', 'Marcus'] },
  'Savings account|Augusta GA': { rank: 5, snippet: 'Best savings rates Augusta GA', competitors: ['Security Federal CU', 'Discover Bank', 'Ally'] },
  'Personal loans|Savannah GA': { rank: 3, snippet: 'Personal loans Coastal Credit Union', competitors: ['LightStream', 'SoFi', 'Marcus'] },
  'Personal loans|Atlanta GA': { rank: 9, snippet: 'Personal loans Atlanta GA', competitors: ['LightStream', 'Upstart', 'Delta Community CU'] },
  'Personal loans|Augusta GA': { rank: 7, snippet: 'Personal financing Augusta Georgia', competitors: ['SRP FCU', 'Upgrade', 'Best Egg'] },
};

// RANKINGS - Client 3: First Metro Bank
const RANK_DATA_CLIENT3 = {
  'Bank near me|Miami FL': { rank: 8, snippet: 'First Metro Bank Miami locations', competitors: ['Bank of America', 'Chase', 'Wells Fargo'] },
  'Bank near me|Orlando FL': { rank: 5, snippet: 'First Metro Bank Orlando FL', competitors: ['Truist', 'Regions', 'SunTrust'] },
  'Bank near me|Tampa FL': { rank: 3, snippet: 'First Metro Bank Tampa Bay area', competitors: ['Regions Bank', 'Chase', 'Fifth Third'] },
  'Business checking|Miami FL': { rank: 2, snippet: 'Business checking accounts Miami', competitors: ['Chase Business', 'Bank of America', 'Wells Fargo'] },
  'Business checking|Orlando FL': { rank: 6, snippet: 'Business banking Orlando Florida', competitors: ['Truist', 'Regions', 'Seacoast Bank'] },
  'Business checking|Tampa FL': { rank: 4, snippet: 'Business checking Tampa FL', competitors: ['Fifth Third', 'Regions', 'Centennial Bank'] },
  'Home equity loan|Miami FL': { rank: 11, snippet: 'Home equity loans Miami FL', competitors: ['Rocket Mortgage', 'Bank of America', 'Figure'] },
  'Home equity loan|Orlando FL': { rank: 7, snippet: 'HELOC Orlando Florida', competitors: ['Truist', 'Discover', 'Regions'] },
  'Home equity loan|Tampa FL': { rank: 5, snippet: 'Home equity financing Tampa', competitors: ['Fifth Third', 'PNC', 'Regions'] },
  'CD rates|Miami FL': { rank: 4, snippet: 'Best CD rates Miami Florida', competitors: ['Marcus', 'Ally Bank', 'Discover'] },
  'CD rates|Orlando FL': { rank: 9, snippet: 'Certificate of deposit Orlando', competitors: ['Synchrony', 'Barclays', 'Capital One'] },
  'CD rates|Tampa FL': { rank: 6, snippet: 'CD rates Tampa Bay area', competitors: ['Marcus', 'CIT Bank', 'Ally'] },
};

// Generate history helper function
function genHistory(startRank) {
  const history = [];
  let rank = startRank;
  for (let w = 8; w >= 0; w--) {
    const d = new Date(2026, 2, 24 - (w * 7));
    history.push({ 
      scanned_at: d.toISOString(), 
      rank: rank === null ? null : Math.max(1, Math.min(20, rank + (Math.random() > 0.5 ? 1 : -1))) 
    });
    if (rank !== null) rank = history[history.length - 1].rank;
  }
  return history;
}

// Build MOCK_RANKINGS for all clients
export const MOCK_RANKINGS = [];

// Client 1 rankings
MOCK_KEYWORDS.filter(k => k.client_id === 1).forEach(k => {
  const key = `${k.keyword}|${k.location}`;
  const d = RANK_DATA_CLIENT1[key] || { rank: null, snippet: '', competitors: [] };
  MOCK_RANKINGS.push({ 
    keyword_id: k.id, 
    keyword: k.keyword, 
    location: k.location, 
    is_target: 1, 
    url: d.rank ? `https://riverbankandtrust.com/page-${k.id}` : null, 
    scanned_at: '2026-03-24T06:00:00Z', 
    ...d 
  });
});

// Client 2 rankings
MOCK_KEYWORDS.filter(k => k.client_id === 2).forEach(k => {
  const key = `${k.keyword}|${k.location}`;
  const d = RANK_DATA_CLIENT2[key] || { rank: null, snippet: '', competitors: [] };
  MOCK_RANKINGS.push({ 
    keyword_id: k.id, 
    keyword: k.keyword, 
    location: k.location, 
    is_target: 1, 
    url: d.rank ? `https://coastalcu.org/page-${k.id}` : null, 
    scanned_at: '2026-03-24T06:00:00Z', 
    ...d 
  });
});

// Client 3 rankings
MOCK_KEYWORDS.filter(k => k.client_id === 3).forEach(k => {
  const key = `${k.keyword}|${k.location}`;
  const d = RANK_DATA_CLIENT3[key] || { rank: null, snippet: '', competitors: [] };
  MOCK_RANKINGS.push({ 
    keyword_id: k.id, 
    keyword: k.keyword, 
    location: k.location, 
    is_target: 1, 
    url: d.rank ? `https://firstmetrobank.com/page-${k.id}` : null, 
    scanned_at: '2026-03-24T06:00:00Z', 
    ...d 
  });
});

// HISTORY for all clients
export const MOCK_HISTORY = {
  // Client 1: River Bank & Trust
  1: MOCK_KEYWORDS.filter(k => k.client_id === 1).flatMap(k => {
    const key = `${k.keyword}|${k.location}`;
    const baseRank = RANK_DATA_CLIENT1[key]?.rank ?? null;
    return genHistory(baseRank).map(h => ({ keyword: k.keyword, location: k.location, rank: h.rank, scanned_at: h.scanned_at }));
  }),
  // Client 2: Coastal Credit Union
  2: MOCK_KEYWORDS.filter(k => k.client_id === 2).flatMap(k => {
    const key = `${k.keyword}|${k.location}`;
    const baseRank = RANK_DATA_CLIENT2[key]?.rank ?? null;
    return genHistory(baseRank).map(h => ({ keyword: k.keyword, location: k.location, rank: h.rank, scanned_at: h.scanned_at }));
  }),
  // Client 3: First Metro Bank
  3: MOCK_KEYWORDS.filter(k => k.client_id === 3).flatMap(k => {
    const key = `${k.keyword}|${k.location}`;
    const baseRank = RANK_DATA_CLIENT3[key]?.rank ?? null;
    return genHistory(baseRank).map(h => ({ keyword: k.keyword, location: k.location, rank: h.rank, scanned_at: h.scanned_at }));
  }),
};

// DISCOVERED KEYWORDS for all clients
export const MOCK_DISCOVERED = {
  // Client 1: River Bank & Trust
  1: [
    { id: 101, client_id: 1, keyword: 'community bank Huntsville', location: 'Huntsville AL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 102, client_id: 1, keyword: 'savings account Huntsville AL', location: 'Huntsville AL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 103, client_id: 1, keyword: 'CD rates Alabama', location: 'Huntsville AL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 104, client_id: 1, keyword: 'SBA loans Alabama', location: 'Birmingham AL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 105, client_id: 1, keyword: 'home equity loan Huntsville', location: 'Huntsville AL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
  ],
  // Client 2: Coastal Credit Union
  2: [
    { id: 201, client_id: 2, keyword: 'best credit union Savannah', location: 'Savannah GA', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 202, client_id: 2, keyword: 'car loan rates Georgia', location: 'Atlanta GA', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 203, client_id: 2, keyword: 'free checking Georgia', location: 'Savannah GA', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 204, client_id: 2, keyword: 'mortgage rates Savannah', location: 'Savannah GA', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 205, client_id: 2, keyword: 'credit union near me Augusta', location: 'Augusta GA', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
  ],
  // Client 3: First Metro Bank
  3: [
    { id: 301, client_id: 3, keyword: 'best bank Miami', location: 'Miami FL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 302, client_id: 3, keyword: 'small business loans Orlando', location: 'Orlando FL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 303, client_id: 3, keyword: 'high yield savings Florida', location: 'Tampa FL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 304, client_id: 3, keyword: 'commercial banking Tampa', location: 'Tampa FL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
    { id: 305, client_id: 3, keyword: 'mortgage lenders Miami FL', location: 'Miami FL', is_target: 0, created_at: '2026-03-24T06:00:00Z' },
  ],
};
